
import { defineComponent } from 'vue'
import { mapMutations } from 'vuex'
import hemisphereService from '@/services/hemisphere.service'
import EmailChangeDialog from '@/components/EmailChangeDialog.vue'
import PasswordChangeDialog from '@/components/PasswordChangeDialog.vue'
import { useSession } from '@/composables/auth'

export default defineComponent({
  props: ['nbAuths', 'nbIts', 'nbTags', 'nbZones', 'nbGateways', 'mylicence'],
  setup() {
    let { user } = useSession()
    return {
      user
    }
  },
  data() {
    return {
      showUpdatePicture: false,
      image: ''
    }
  },
  computed: {
    userFullName(): string {
      return this.user.first_name + ' ' + this.user.last_name
    },
    lastLoginDate(): string {
      if (this.user.last_login) {
        const date = new Date(this.user.last_login)
        const d = date.toLocaleString()
        return d
      } else return ''
    },
    userLicense(): string {
      return this.user.company ? this.$t('user-license.pro') : this.$t('user-license.individual')
    }
  },
  methods: {
    ...mapMutations('auth', ['SET_SESSION']),
    getSub() {
      if (this.mylicence.category_label || this.mylicence.type_label) {
        return this.mylicence.category_label + ' ' + this.mylicence.type_label
      } else {
        return 'Formule Liberté'
      }
    },
    changeEmail() {
      let x: any = this.$refs.emailChangeDialog
      x.show()
    },
    changePassword() {
      let x: any = this.$refs.passwordChangeDialog
      x.show()
    },
    editUserProfile() {
      this.$router.push('/user-profile')
    }
  },
  components: { EmailChangeDialog, PasswordChangeDialog }
})
